import { AlertController } from 'ionic-angular';
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

@Injectable()
export class SincronizarServiceProvider {

    private mensagem: Array<any>;
    private url: string = '';

    constructor(private http: Http, private alertCtrl: AlertController) {

    }

    fetchData(rest: string): Promise<any> {

        this.url = rest;

        let alertctrl = this.alertCtrl.create({
            title: 'Conexão falhou!',
            subTitle: 'Favor verificar acesso à internet.',
            buttons: ['Fechar']
        });

        // let headers = new Headers({ "Accept-Encoding": "gzip", "Content-Encoding": "gzip" });
        // let options = new RequestOptions({ headers: headers });
    
        return new Promise(resolve => {
            this.http.get(this.url).map(res => res.json())
                .subscribe(
                data => {
                    this.mensagem = data;
                    resolve(this.mensagem);
                }, err => {                    
                    if (err.json().errorMessage) {
                        alertctrl.setSubTitle(err.json().errorMessage);
                        alertctrl.present();
                        resolve(false);
                    } else {
                        alertctrl.present();
                        resolve(false);
                    }
                })
        });

    }

    postData(rest: string, body: any) {
        return new Promise((resolve, reject) => {
            this.http.post(rest, JSON.stringify(body))
                .subscribe(res => {
                    resolve(res.json());
                }, (err) => {
                    reject(err.json());
                });
        });
    }


}



// WEBPACK FOOTER //
// ./src/providers/sincronizar-service.ts